// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F8dh","controls":"styles_controls__27m7o","charLimit":"styles_charLimit__3FuXc","input":"styles_input__2_633","send":"styles_send__1jYuV"};